import React from "react";
import WidgetContainer from "../../../components/WidgetContainer/WidgetContainer";

import "./ContactUsMerchantSupport.css";
import PostCardIcon from "../../../images/contact-us/post.svg";
import PhoneIcon from "../../../images/contact-us/telephone.svg";
const ContactUsMerchantSupport = () => {
    return (
        <WidgetContainer>
            <div className="cu-merchant-support">
                <div className="cu-merchant-support__head">
                    <h1>Merchant Support - Details</h1>
                    <p>
                        Get help with onboarding as a partner, payments at
                        stores, online payments, business related queries and
                        more!
                    </p>
                </div>
                <div className="cu-merchant-support__content">
                    <div className="cu-merchant-support__content__item">
                        <h2>Get on-boarded as a Merchant</h2>
                        <p>
                            Start accepting payments with PhonePe &amp; grow
                            your business
                        </p>
                        <div className="cu-merchant-support__content__item__cbp">
                            <p>
                                <img
                                    src={PostCardIcon}
                                    width="34"
                                    height="24"
                                    alt="Post Card Icon"
                                />
                            </p>
                            <p>
                                <a
                                    className="purple-text"
                                    href="https://support.phonepe.com/"
                                    target="_top"
                                >
                                    Send a message
                                </a>
                                <br /> Response Time : within 24 hours
                            </p>
                        </div>
                    </div>
                    <div className="cu-merchant-support__content__item">
                        <h2>Merchant Helpdesk</h2>
                        <p>
                            Give us a call and we'll help you find the answers.
                        </p>
                        <div className="cu-merchant-support__content__item__cbp">
                            <p>
                                <img
                                    src={PhoneIcon}
                                    width="28"
                                    height="28"
                                    alt="Phone Icon"
                                />
                            </p>
                            <p id="cs-pn">
                                080-6872-7777
                                <br /> 022-6872-7777
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </WidgetContainer>
    );
};

export default ContactUsMerchantSupport;
